export default __webpack_public_path__ + "static/media/Group-146-Yono@2x.7525a875.png";